
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import BaseUpload from './BaseUpload.vue';
// @ts-ignore
import CircleProgress from 'vue-circleprogressbar';
import FileItem from './FileItem.vue';
import { creatMaterialFileSymlink } from '@/api/placeOrder';
import { handleUrl } from '../../helper';
import { IFileList, IOrderForm } from '@/types/placeOrderTypes';
import { FileTypes, UploadService } from './fileOperations';
import { Action, Getter } from 'vuex-class';
import { IServiceMap } from '@/business/BusinessFormData';
import { ServiceContentEnum } from '@/business/ServiceContent';

@Component({
  components: {
    BaseUpload,
    CircleProgress,
    FileItem,
  },
})
export default class JsonUpload extends Vue {
  @Action('setOrderId') setOrderId: any
  @Getter('user') user: any

  @Prop({ default: false }) checking!: boolean
  @Prop({ default: false }) uploading!: boolean
  @Prop({ default: () => [] }) jsonList!: any[]
  @Prop({}) formInfo!: IServiceMap
  @Prop() form!: IOrderForm
  @Prop({ required: true }) order_id!: string
  @Prop() files!: IFileList[]
  @Prop() screenForm!: Function
  @Prop() checkForm!: Function
  @Prop() selectFileType!: number

  title = 'JSON文件'

  get JsonToPpt () {
    if (!this.formInfo || !this.formInfo.formData) {
      console.error('JsonUpload.vue: formInfo或formData未定义');
      return false;
    }

    const result = this.formInfo.formData.service_content === ServiceContentEnum.JsonToPpt;
    return result;
  }

  get showMoreButton () {
    return false;
  }

  get accept () {
    return '.json';
  }

  get multiple () {
    return true;
  }

  @Emit('update:jsonList')
  updateJsonList (list: any[]) {
    return list;
  }

  @Emit('upload-start')
  setUploading (value: boolean) {
    return value;
  }

  async handleFileSelected (files: any[]) {
    if (files.length) {
      this.updateJsonList([...this.jsonList, ...files]);
    }
  }

  selectMore () {
    ;(this.$refs.baseUpload as any).selectFile();
  }

  async startUpload () {
    await UploadService.uploadFiles({
      context: this,
      fileList: this.jsonList,
      fileType: FileTypes.JSON,
      screenForm: this.screenForm,
      checkForm: this.checkForm,
      filterCondition: (item, form) =>
        item.json && !form.material.oss_json_files.filter((json: any) => json!.name === item.json!.name).length,
      handleExistingFile: async (item, path, form) => {
        if (!form.material.oss_json_files) form.material.oss_json_files = [];

        const symlinkData = await creatMaterialFileSymlink({
          ticket_id: this.order_id,
          origin_path: path,
          name: item.json!.name,
          path_alias: 'content_word',
        });
        // 读取JSON文件内容并处理转义字符
        const jsonData = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          let content = '';
          reader.onload = (e) => {
            const result = e.target?.result;
            if (typeof result === 'string') {
              try {
                content = JSON.parse(result);
                resolve(content);
              } catch (error) {
                this.$message.error('JSON文件格式错误');
                reject('JSON文件格式错误');
              }
            } else {
              this.$message.error('JSON文件格式错误');
              reject('JSON文件格式错误');
            }
          };
          reader.onerror = () => {
            resolve('');
          };
          reader.readAsText(item.json);
        });
        form.material.oss_json_files.push({
          path: handleUrl(symlinkData.symlink_path),
          is_del: false,
          extension: 'json',
          name: item.json!.name,
          md5: item.md5,
          // 使用读取到的实际JSON文件内容
          json_data: jsonData || ''
        });
      },
      afterUpload: (item, symlinkData, form) => {
        if (!form.material.oss_json_files) form.material.oss_json_files = [];

        form.material.oss_json_files.push({
          path: symlinkData.symlink_path,
          is_del: false,
          extension: 'json',
          name: item.json!.name,
          md5: item.md5,
        });
      },
      onUploadFinished: async fileList => {
        if (this.JsonToPpt) {
          let projects = this.form.xdoc_planning || [];

          if (projects.length) {
            projects[0].origin_files = [
              {
                index: 0,
                type: 1,
                name: fileList[0].json?.name || '',
                selected: false,
              },
            ];
          } else {
            projects = [
              {
                name: this.form.alias + '-图书',
                config: {
                  fbd_type: 0,
                  delivery: 16,
                },
                origin_files: [
                  {
                    index: 0,
                    type: 1,
                    name: fileList[0].name || fileList[0].json?.name || '',
                    selected: false,
                  },
                ],
              },
            ];
          }
          this.$set(this.form, 'xdoc_planning', projects);
        }
      },
    });
  }
  removeJsonFile (name: string) {
    const jsonIndex = this.files.findIndex(item => item.json && item.json.name === name);
    const ListIndex = this.jsonList.findIndex(item => item.json && item.json.name === name);
    this.files.splice(jsonIndex, 1);
    this.jsonList.splice(ListIndex, 1);
    if (
      this.form &&
      this.form.material.oss_json_files &&
      this.form.material.oss_json_files.filter(item => item.name === name).length
    ) {
      this.form.material.oss_json_files.splice(ListIndex, 1);
    }
  }
}
